import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { memberUserReducer } from './member-user.reducer';
import { MemberUserEffects } from './member-user.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('memberUsers', memberUserReducer),
    EffectsModule.forFeature([MemberUserEffects]),
  ],
  providers: [],
})
export class MemberUserStoreModule {}
